"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { ChevronRight, Home } from "lucide-react";

const LABELS: Record<string, string> = {
  actualites: "Actualités",
  agenda: "Agenda",
  "services-municipaux": "Services Municipaux",
  urbanisme: "Urbanisme",
  contact: "Contact",
  "mentions-legales": "Mentions légales",
  "politique-confidentialite": "Politique de confidentialité",
  accessibilite: "Accessibilité",
  elus: "Élus",
  urgences: "Numéros d'urgence",
  galerie: "Galerie",
};

export default function Breadcrumb({ currentLabel }: { currentLabel?: string }) {
  const pathname = usePathname();
  const segments = pathname.split("/").filter(Boolean);

  if (segments.length === 0) return null;

  const crumbs = segments.map((seg, i) => {
    const href = "/" + segments.slice(0, i + 1).join("/");
    const label = LABELS[seg] ?? currentLabel ?? seg;
    const isLast = i === segments.length - 1;
    return { href, label, isLast };
  });

  return (
    <nav aria-label="Fil d'Ariane" className="flex items-center gap-1 text-sm text-slate-500">
      <Link
        href="/"
        className="flex items-center gap-1 transition-colors hover:text-slate-800"
        aria-label="Accueil"
      >
        <Home size={13} />
      </Link>
      {crumbs.map((crumb) => (
        <span key={crumb.href} className="flex items-center gap-1">
          <ChevronRight size={13} className="text-slate-300" />
          {crumb.isLast ? (
            <span className="font-medium text-slate-800 truncate max-w-[200px]" aria-current="page">
              {crumb.label}
            </span>
          ) : (
            <Link href={crumb.href} className="transition-colors hover:text-slate-800 truncate max-w-[160px]">
              {crumb.label}
            </Link>
          )}
        </span>
      ))}
    </nav>
  );
}
